//制造业重大项目方向

const indexAdmin = () => import('./indexAdmin');
const indexAppl = () => import(/* webpackChunkName: "herb" */ './indexAppl');
const edit = () => import('./edit.vue');

export default {
  routes: [
    {
      path: '/prodIncentive/v2025/indexAppl',
      name: 'prodIncentive_v2025_index_appl',
      component: indexAppl,
      meta:{public:true}
    },
    {
      path: '/prodIncentive/v2025/indexAdmin',
      name: 'prodIncentive_v2025_index_admin',
      component: indexAdmin,
      meta: {public: true}
    },
    {
      path: '/prodIncentive/v2025/edit',
      name: 'prodIncentive_v2025_edit',
      component: edit,
      meta: {public: true}
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/prodIncentive/v2025/router.js